/* eslint-disable eqeqeq */
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import FormVolumeNfe from '../form-volume-nfe';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        marginTop: theme.spacing(2),
    },
    controlaBotao: {
        margin: 2,
        width: "100%",
    },
    controlaFiltrar: {
        backgroundColor: "#F1F1F1",
        margin: 2,
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
    },
    textField: {
        margin: theme.spacing(1),
        width: "100%"
    },
    root: {
        width: '100%',
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
    visualmenteEscondido: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    popper: {
        padding: theme.spacing(1),
    },
    ocultaCampo: {
        display: "none",
    },
}));


export default function ListagemNfeVolume(props) {

    const { volumesNota, adicionarVolume, removerVolume, inativo } = props;
    const classes = useStyles();

    return (
        <>
            <Paper className={volumesNota.length == 0 ? classes.ocultaCampo : classes.root}>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ação</TableCell>
                                <TableCell>Quantidade</TableCell>
                                <TableCell>Peso Bruto</TableCell>
                                <TableCell>Peso Liquido</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {volumesNota.map((volume, indexVolume) => (
                                <TableRow key={volume.codigoItem}>
                                    <TableCell>
                                        <FormVolumeNfe
                                            adicionarVolume={adicionarVolume}
                                            removerVolume={removerVolume}
                                            grid="true"
                                            volumeNfe={volume}
                                            indexVolume={indexVolume}
                                            inativo={inativo}
                                        />
                                    </TableCell>
                                    <TableCell>{volume.quantidade}</TableCell>
                                    <TableCell>{volume.pesoBruto}</TableCell>
                                    <TableCell>{volume.pesoLiquido}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        </>

    )
}